import { TranslationsPage } from '@hendrx/core/translations';
import { createFileRoute } from '@tanstack/react-router';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import { requireRole } from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/translations')({
  beforeLoad: createRouteGuard(requireRole('admin')),
  component: TranslationsPage
});
